"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unescapeMarkdown = unescapeMarkdown;
/**
 * Unescapes markdown content that has been escaped for JSON
 */
function unescapeMarkdown(escapedMarkdown) {
    try {
        return JSON.parse("\"".concat(escapedMarkdown, "\""));
    }
    catch (_a) {
        return escapedMarkdown;
    }
}
